export const ErrorPage = () => {
  throw new Error('Error message');
};
